// Crear y encontrar diseños — ADR-2026-09-17-un-diseno-es-un-chat. Un diseño es una fila
// de `agent_chats` con `tipo = 'diseno_indumentaria'`, sin mensajes, con su lienzo ya
// escrito (las imágenes propias con las que nace). Listarlos es `listDisenos`.

import { LIENZO_VACIO, conDiseno } from '../../../../chat-atlas/lienzo/persistenciaDelLienzo';
import { TIPO_CHAT_DISENO, createChat, deleteChats, guardarLienzo } from '../../agentChatApi';
import { conImagenPropia, type ImagenPropia } from './disenoGuardado';

export const RUTA_DISENO = '/diseno-de-indumentaria';
export const rutaDelDiseno = (id: string): string => `${RUTA_DISENO}/${id}`;

/** Clave del `location.state` con el texto de una prenda descrita en la portada: el
 *  lienzo la lee al montar y pide la base (Tarea 11). */
export const ESTADO_BASE_DESCRITA = 'baseDescrita';

export function idDeImagenPropia(): string {
  return `img-${crypto.randomUUID().slice(0, 8)}`;
}

export async function crearDiseno(args: {
  userId: string;
  companyId: string;
  titulo: string;
  imagenes: ImagenPropia[];
}): Promise<string | null> {
  const id = await createChat({
    userId: args.userId,
    companyId: args.companyId,
    title: args.titulo,
    messages: [],
    tipo: TIPO_CHAT_DISENO,
  });
  if (!id) return null;
  const lienzo = conDiseno(LIENZO_VACIO, (d) => args.imagenes.reduce(conImagenPropia, d));
  // Si el lienzo no se guardó, el diseño quedaría vacío (sin su base) y sin manera de
  // recuperarla: se avisa como si no se hubiera creado, y la portada muestra el error.
  // Como `listDisenos` lista TODA fila con `tipo = diseno_indumentaria` (mire o no su
  // lienzo), la fila que quedó tendría que aparecer en "recientes" como un diseño vacío
  // que no se puede abrir, y cada reintento sumaría otro: se borra
  // (ADR-2026-09-18-crear-un-diseno-es-todo-o-nada).
  if (!(await guardarLienzo(id, lienzo))) {
    await deleteChats([id], args.userId);
    return null;
  }
  return id;
}
